import React, { useEffect, useState } from "react";
import paymentService from "@irati/payments/services/Payments";
import { hangPromise } from "@irati/utils/promise";
import Loading from "@irati/ui/src/Loading";
import tracking from "@irati-tracking/perks/perks";
var PaymentFormZip = function (_a) {
    var paymentOrder = _a.paymentOrder, redirectReturnUrl = _a.redirectReturnUrl;
    var _b = useState(hangPromise()), load = _b[0], setLoad = _b[1];
    useEffect(function () {
        tracking.paymentMethodSelected("ZIP");
        var payDetails = {
            amount: paymentOrder.amount,
            resUrl: redirectReturnUrl
        };
        setLoad(paymentService.payByZip(paymentOrder, payDetails).then(function (_a) {
            var details = _a.details;
            window.location = details.url;
        }));
    }, []);
    return React.createElement(Loading, { load: load });
};
export default PaymentFormZip;
